
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'

@Observer
@Component({
  components: {
    InfiniteLoading
  }
})
export default class ExchangeRecord extends Vue {
  get pagePagination() {
    return this.$store.$myV2.Account.Exchange.recordPagePagination
  }
  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
